import * as React from 'react';
import { useContext, useState } from 'react';

import { Progress } from '@shared/components/bootstrap';
import { Text } from '@shared/components/bootstrap';
import { useActiveStorageDirectUpload } from '@shared/hooks/use_active_storage_direct_upload';
import type { ActiveSupportDirectUploadUploader } from '@shared/hooks/use_active_storage_direct_upload';
import type { LegacyAttachmentUploadUploader } from '@shared/hooks/use_legacy_attachment_upload';

import { Context } from './context';

export const Uploader: React.FC<{
  file: File;
  uuid: string;
  uploader?: ActiveSupportDirectUploadUploader | LegacyAttachmentUploadUploader;
}> = ({ file, uuid, uploader = useActiveStorageDirectUpload }) => {
  const [error, setError] = useState<Error | string | undefined>(undefined);
  const { onCancel, onUpload } = useContext(Context);

  const { loaded, total, retry } = uploader({
    file,
    onUpload: (upload) => {
      setError(undefined);
      onUpload(file, uuid, typeof upload === 'string' ? upload : upload.signed_id);
    },
    onError: setError,
  });

  const onDelete = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onCancel(file, uuid);
  };

  const onRetry = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setError(undefined);
    retry();
  };

  return (
    <>
      <Text wrapping="truncate" tag="div">
        {file.name}
      </Text>
      {error && (
        <Text tag="div">
          <a href="#" onClick={onDelete}>
            Delete
          </a>
          <span> | </span>
          <a href="#" onClick={onRetry}>
            Retry
          </a>
          <span> - </span>
          <Text tag="span" style="danger">
            {typeof error === 'string' ? error : error.message}
          </Text>
        </Text>
      )}
      <Progress>
        {!error && loaded !== undefined && total !== undefined && <Progress.Bar loaded={loaded} total={total} />}
      </Progress>
    </>
  );
};
